/**
 * Informations légales de l'éditeur et de l'hébergeur (article 6 de la LCEN).
 *
 * Source unique : les pages Mentions légales, Confidentialité et CGU s'y réfèrent, jamais des textes recopiés.
 * Identité vérifiée le 2026-09-24 dans la base Sirene (recherche-entreprises.api.gouv.fr) :
 * SIREN actif, entrepreneur individuel, activité 62.01Z, siège 31 rue de la Fresnaie 95120 Ermont.
 */
export interface Publisher {
  readonly name: string;
  readonly status: string;
  readonly address: string;
  readonly siren: string;
  readonly siret: string;
  readonly activity: string;
  readonly website: string;
  /** Vide tant que l'adresse n'est pas fournie : la ligne de contact n'est alors pas affichée. */
  readonly email: string;
  readonly phone: string;
  /**
   * Numéro de TVA intracommunautaire si tu y es assujetti (obligatoire dans ce cas).
   * Laisser vide si franchise en base : aucune mention de TVA ne sera alors affichée.
   */
  readonly vatNumber: string;
  readonly publicationDirector: string;
}

export const PUBLISHER: Publisher = {
  name: 'Christophe Bellec',
  status: 'Entrepreneur individuel',
  address: '31 rue de la Fresnaie, 95120 Ermont, France',
  siren: '529 061 533',
  siret: '529 061 533 00038',
  activity: 'Programmation informatique (code APE 62.01Z)',
  website: 'https://bellec-services.com',
  /**
   * Moyen de contact direct exigé par la LCEN (« entrer en contact rapidement »).
   * ⚠️ À RENSEIGNER avant la mise en ligne : sans cette adresse, les mentions légales sont incomplètes.
   */
  email: 'contact@bellec-services.com',
  /** Téléphone, si tu préfères l'afficher en plus ou à la place de l'e-mail. */
  phone: '',
  vatNumber: 'FR92 529 061 533',
  publicationDirector: 'Christophe Bellec',
};

/** Hébergeur : coordonnées relevées le 2026-09-24 sur cloudflare.com/website-terms. */
export const HOST = {
  name: 'Cloudflare, Inc.',
  address: '101 Townsend St, San Francisco, CA 94107, États-Unis',
  phone: '+1 650 319 8930',
  website: 'https://www.cloudflare.com',
};

/**
 * Tiers contactés **par le navigateur du visiteur** : eux seuls voient son adresse IP.
 * Les fournisseurs de données (IDFM, Open-Meteo, Atmo France, Météo-France, Annuaire, Ville d'Ermont)
 * sont appelés par notre serveur : ils ne reçoivent jamais l'adresse IP du visiteur.
 */
export const BROWSER_THIRD_PARTIES: readonly {
  readonly name: string;
  readonly purpose: string;
  readonly url: string;
  readonly onDemand: boolean;
}[] = [
  {
    name: 'OpenFreeMap',
    purpose: 'fond de carte (tuiles), chargé quand une carte est affichée',
    url: 'https://openfreemap.org',
    onDemand: false,
  },
  {
    name: 'Cloudflare Web Analytics',
    purpose:
      'mesure d’audience sans cookie ni identifiant persistant (pages vues, provenance, performances) ; aucun profil, aucun suivi individuel',
    url: 'https://www.cloudflare.com/web-analytics/',
    onDemand: false,
  },
  {
    name: 'Windy.com',
    purpose: 'lecteur de la webcam de ciel, chargé uniquement après un clic sur « Voir le ciel en direct »',
    url: 'https://www.windy.com',
    onDemand: true,
  },
];
